import { apiFetch } from "./api";

export const deletePending = async (id) => {
    const obj = {
        method: 'POST',
        body: {
            pending_id: id,
            option: 'delete_pending',
        }
    }

    const response = await apiFetch(obj);

    return response;
};
